'use strict';
import angular from 'angular';

import './ec.services';

angular.module('core.custommade.ec', [
    'ec.services',
]);

